/* FLOOF .. ADD TO CART FROM A GRID CARD

   Owns the colour swatches and the Add button on .f-card, nothing else.
   Delegated from document so paginated / re-rendered cards need no re-binding.

   NO ARITHMETIC HERE. Liquid rendered every price onto its swatch as a finished
   string, and the drawer is re-fetched from the server as HTML .. same discipline
   as floof-cart.js. Any number computed here would be the wrong one.

   OWNERSHIP, since this is the second thing in the theme that mutates the cart:
     bag badge       -> floof-nav-js.liquid, which wraps window.fetch and so
                        already sees the /cart/add.js below. Do not touch it here.
     drawer HTML     -> re-rendered below via Section Rendering, as floof-cart.js does.
     drawer controls -> floof-cart.js, by delegation, which is why swapping the
                        section's innerHTML does not unbind its steppers.

   The drawer is a STATICALLY rendered section, so its id really is the bare
   'floof-cart-drawer'. That is the exception: template section ids are NOT their
   template.json keys, and a wrong one returns 200 with null and fails silently.
   See the header of sections/floof-cart.liquid. */
(function () {
  if (window.__floofQuickAdd) return;   // the section can render more than once
  window.__floofQuickAdd = true;

  var DRAWER = 'floof-cart-drawer';

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var sw = e.target.closest('[data-sw]');
    if (sw) { pick(sw); return; }
    var btn = e.target.closest('[data-add]');
    if (btn && !btn.disabled) { e.preventDefault(); add(btn); }
  });

  /* Choosing a colour retargets the SAME button rather than opening anything.
     Label and disabled state follow the chosen variant, because a sold-out
     colourway is reachable now that inventory is finite. */
  function pick(sw) {
    var card = sw.closest('.f-card');
    var btn = card.querySelector('[data-add]');
    var price = card.querySelector('[data-card-price]');

    Array.prototype.forEach.call(sw.parentElement.querySelectorAll('[data-sw]'), function (b) {
      var on = b === sw;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var sold = sw.getAttribute('data-sold') === 'true';
    btn.setAttribute('data-vid', sw.getAttribute('data-vid'));
    btn.disabled = sold;
    btn.textContent = sold ? btn.getAttribute('data-soldlabel') : btn.getAttribute('data-label');
    if (price && sw.getAttribute('data-price')) price.textContent = sw.getAttribute('data-price');
  }

  function add(btn) {
    var label = btn.getAttribute('data-label');
    btn.classList.add('is-busy');
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-vid')), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { return r.ok ? j : Promise.reject(j); }); })
      .then(refreshDrawer)
      .then(function () {
        btn.classList.remove('is-busy');
        btn.classList.add('is-done');
        btn.textContent = btn.getAttribute('data-done');
        openDrawer();
        setTimeout(function () {
          btn.classList.remove('is-done');
          btn.textContent = label;
          btn.disabled = false;
        }, 2200);
      })
      .catch(function (err) {
        /* Shopify's own description is the useful message .. "only 2 left" is a
           fact the client cannot work out for itself. */
        btn.classList.remove('is-busy');
        btn.textContent = (err && err.description) || btn.getAttribute('data-err');
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 3000);
      });
  }

  function refreshDrawer() {
    return fetch('/?sections=' + DRAWER)
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j[DRAWER];
        if (!html) return;              // 200 + null is the silent-failure case
        var host = document.getElementById('shopify-section-' + DRAWER);
        if (host) host.innerHTML = html;
      });
  }

  /* Re-queried, never cached: refreshDrawer just replaced the node. */
  function openDrawer() {
    var d = document.getElementById('FloofCart');
    if (d && typeof d.showModal === 'function' && !d.open) d.showModal();
  }
})();
